import JsFileDownloader from 'js-file-downloader';
import { toast } from 'react-toastify';

export const handleFileDownload = ({
  url,
  filename,
  successMessage,
  errorMessage,
}: {
  url: string;
  filename?: string;
  successMessage: string;
  errorMessage: string;
}) => {
  new JsFileDownloader({
    url,
    filename,
  })
    .then(() => {
      toast.success(successMessage);
    })
    .catch(() => {
      toast.error(errorMessage);
    });
};
